import {component} from '@reduct/component';

import BadToelzAPI from '../../API/BadToelz';
import ValidationParser from '../../Utils/ValidationParser/Util.js';
import app from '../../assembler';

function createErrorMessage(msg) {
	const errorMessage = document.createElement('div');
	errorMessage.innerHTML = msg;
	errorMessage.classList.add('errorMessage');

	return errorMessage;
};

@component()
class ContactStageForm {
	constructor() {
		this.badToelzAPI = new BadToelzAPI();
		this.errorMessages = {};

		this.el.querySelectorAll('[data-ds="validationMessages"] div').forEach(node => {
			this.errorMessages[node.getAttribute('data-name')] = node.getAttribute('data-message');
		});

		this.el.querySelector('form').addEventListener('submit', this.handleSubmit);
		this.validationParser = new ValidationParser(this.getElement(), {
			beforeValidation: this.resetValidationErrors,
			onValidationFailed: this.handleValidationError
		});
	}

	resetValidationErrors = () => {
		this.el.querySelectorAll('.errorMessage').forEach(errorMessage => errorMessage.remove());
		this.el.querySelectorAll('.hasError').forEach(hasError => hasError.classList.remove('hasError'));
	}

	handleValidationError = (field, reason) => {
		if (field.getAttribute('data-surrogate')) {
			this.handleValidationError(
				field.parentNode.querySelector(field.getAttribute('data-surrogate')),
				reason
			);
		}

		field.classList.add('hasError');
		field.parentNode.classList.add('hasError');
		field.parentNode.insertBefore(createErrorMessage(this.errorMessages[reason]), field.nextSibling);
	}

	handleSubmit = event => {
		event.preventDefault();

		if (!this.validationParser.validate()) {
			return false;
		}

		const [name, email, message] =
			['name', 'email', 'message'].map(
				(key) => this.el.querySelector(`[name="${key}"]`).value
			);

		this.badToelzAPI.sendContactRequest(name, email, message);
		this.remove();
		return false;
	}

	remove() {
		this.getElement().remove();
	}
}

app.register(ContactStageForm, 'ContactStageForm');
